import styled from "@emotion/styled";

export const Row = styled.div`
  display: flex;
  align-content: stretch;
  margin: ${({ theme }) => theme.spacing(2)};
  & > :not(style) {
    margin: 0;
    margin-right: ${({ theme }) => theme.spacing(2)};
    flex-grow: 1;
  }
  & > *:last-child {
    margin-right: 0;
  }
`;
